var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKhamDoanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#616BAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33080_108852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0017 15.3531C20.0224 15.3531 21.6606 13.7071 21.6606 11.6766C21.6606 9.64605 20.0224 8 18.0017 8C15.9809 8 14.3428 9.64605 14.3428 11.6766C14.3428 13.7071 15.9809 15.3531 18.0017 15.3531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7198 15.8446C20.0106 16.4438 19.1422 16.7085 18.0017 16.7085C16.8612 16.7085 16.0941 16.4496 15.272 15.833C12.7131 16.3013 11.8389 18.826 11.8389 20.7894V21.6067C11.8389 22.3542 12.2123 23.0581 12.8404 23.4624C13.0344 23.5875 13.2602 23.7126 13.5265 23.8348C13.703 26.1617 15.6425 28 18.0046 28C20.3637 28 22.3061 26.1617 22.4826 23.8318C22.7345 23.7155 22.9545 23.5962 23.1397 23.477C23.7795 23.0698 24.1674 22.3659 24.1674 21.6038V20.7865C24.1645 18.9802 23.3771 16.3537 20.7198 15.8446ZM18.0017 27.2204C15.9551 27.2204 14.2878 25.548 14.2878 23.4886C14.2878 21.4293 15.9522 19.7568 18.0017 19.7568C20.0482 19.7568 21.7156 21.4293 21.7156 23.4886C21.7156 25.548 20.0482 27.2204 18.0017 27.2204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3773 13.5699C26.8785 13.5699 28.0954 12.3471 28.0954 10.8387C28.0954 9.33024 26.8785 8.10742 25.3773 8.10742C23.8761 8.10742 22.6592 9.33024 22.6592 10.8387C22.6592 12.3471 23.8761 13.5699 25.3773 13.5699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3978 13.9335C26.871 14.3786 26.2255 14.5734 25.3773 14.5734C24.5292 14.5734 23.9618 14.3815 23.351 13.9248C22.5782 14.0673 22.0108 14.46 21.6113 14.9777C22.7837 15.3733 23.7273 16.1674 24.3642 17.3076C25.0155 18.4711 25.1863 19.6927 25.2181 20.4693C25.2702 20.4693 25.3252 20.4693 25.3773 20.4693C27.366 20.4693 28.5325 20.0243 29.1925 19.6054C29.6673 19.3029 29.9567 18.7794 29.9567 18.2151V17.6072C29.9567 16.2634 29.372 14.3117 27.3978 13.9335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6234 13.5699C12.1246 13.5699 13.3415 12.3471 13.3415 10.8387C13.3415 9.33024 12.1246 8.10742 10.6234 8.10742C9.12221 8.10742 7.90527 9.33024 7.90527 10.8387C7.90527 12.3471 9.12221 13.5699 10.6234 13.5699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80814 19.6054C7.46813 20.0243 8.63469 20.4693 10.6233 20.4693C10.6783 20.4693 10.7305 20.4693 10.7826 20.4693C10.8173 19.6927 10.9881 18.474 11.6365 17.3076C12.2733 16.1674 13.217 15.3733 14.3893 14.9777C13.9899 14.46 13.4225 14.0673 12.6496 13.9248C12.0389 14.3815 11.4686 14.5734 10.6233 14.5734C9.7752 14.5734 9.12969 14.3786 8.60285 13.9335C6.62867 14.3117 6.04395 16.2634 6.04395 17.6072V18.2151C6.04395 18.7794 6.33341 19.3029 6.80814 19.6054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8577 23.0988H18.3901V21.6241C18.3901 21.4089 18.2164 21.2344 18.0022 21.2344C17.788 21.2344 17.6143 21.4089 17.6143 21.6241V23.0988H16.1467C15.9325 23.0988 15.7588 23.2734 15.7588 23.4886C15.7588 23.7038 15.9325 23.8784 16.1467 23.8784H17.6143V25.353C17.6143 25.5683 17.788 25.7428 18.0022 25.7428C18.2164 25.7428 18.3901 25.5683 18.3901 25.353V23.8784H19.8577C20.0719 23.8784 20.2456 23.7038 20.2456 23.4886C20.2456 23.2734 20.0719 23.0988 19.8577 23.0988Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33080_108852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.913,
    height: 20,
    fill: "white",
    transform: "translate(6.04395 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKhamDoanIcon);
export default __webpack_public_path__ + "static/media/KhamDoanIcon.23f39908.svg";
export { ForwardRef as ReactComponent };